var React = require('react');

function BaselinePlayArrow24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 5v14l11-7z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

BaselinePlayArrow24px.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BaselinePlayArrow24px;

BaselinePlayArrow24px.default = BaselinePlayArrow24px;
